import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CFMultiSelect } from 'multiselect';
import * as actions from './redux/scorecard_data_actions';
import { bindActionCreators } from 'redux';

export class ScorecardToolbar extends Component {
  constructor(props){
    super(props)
    
    this.state = {
      scorecardItemsSelected: [],
      scorecardOptions: []
    }

    this.scorecardsChanged = this.scorecardsChanged.bind(this);
  }

  scorecardsChanged(selected) {

    if(this.props.actions.setScorecardSelectedItems) {
      this.props.actions.setScorecardSelectedItems(selected);
    }
		this.setState({ scorecardItemsSelected: selected });
  }

  renderSelected = (selected, options) => {

    //return if one or all items are selected
    if(selected.length === options.length || selected.length === 1) {
      return;
    }

    let currentSelectedItems = [];
    
    selected.forEach((x) => {
      let i = options.findIndex(y => {
        return x === y.value
      });

      if(i > 0) {
        currentSelectedItems.push(options[i].label);
      }
    });
    
    if(selected.length > 1) {
      return selected.length + " Metrics (" + currentSelectedItems.join() + ")"
    }
  }
  
  componentWillReceiveProps(nextProps) {
    let t = [];
    let o = [];
    if(this.props.scorecards !== nextProps.scorecards) {

      //set all cards to be selected
      nextProps.scorecards.forEach(e => {
          t.push(e.scorecardId);

          //set the drop down options
          o.push({
            label: e.scorecardDisplayName,
            value: e.scorecardId
          })
      });
    }

    //sort a-z options dropdown
    var sortedOptions = o.sort(function (a, b) {
      if (a.label < b.label) return -1;
      else if (a.label > b.label) return 1;
      return 0;
    });
    this.setState({ scorecardItemsSelected: t });
    this.setState({scorecardOptions: sortedOptions});
  }

  render() {
    let overrideStrings=({
      selectSomeItems: "Select Metrics To View",
      allItemsAreSelected: "All Metrics"
    });

    return (
      <div className="scorecard-toolbar">
        <CFMultiSelect
            options={this.state.scorecardOptions}
            selectAllLabel={"All Metrics"}
            onChange={(selected) => this.scorecardsChanged(selected)}
            ref={
              (input) => this.contactTypeInput = input
            }
            selected={this.state.scorecardItemsSelected} 
            isLoading={false}
            disabled={false}
            disableSearch={true}
            overrideStrings={overrideStrings}
            valueRenderer={this.renderSelected}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScorecardToolbar);



// WEBPACK FOOTER //
// ./src/features/scorecard/ScorecardToolbar.js